var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5398 6.49888C22.4155 6.01564 22.1704 5.57458 21.8291 5.21988C21.4877 4.86518 21.062 4.60929 20.5947 4.47782C18.8796 4 12 4 12 4C12 4 5.12042 4 3.40442 4.47782C2.93729 4.60952 2.51185 4.86551 2.17065 5.22018C1.82946 5.57486 1.58446 6.01579 1.46017 6.49888C1 8.28149 1 12 1 12C1 12 1 15.7185 1.46017 17.5011C1.58445 17.9844 1.82956 18.4254 2.17094 18.7801C2.51232 19.1348 2.938 19.3907 3.40533 19.5222C5.12042 20 12 20 12 20C12 20 18.8796 20 20.5956 19.5222C21.063 19.3908 21.4887 19.1349 21.8301 18.7802C22.1715 18.4255 22.4165 17.9844 22.5408 17.5011C23 15.7185 23 12 23 12C23 12 23 8.28149 22.5398 6.49888ZM9.74958 15.376V8.62401L15.4998 12L9.74958 15.376Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.24bd809c678e86917514f0de294bab62.svg";
export { ForwardRef as ReactComponent };